module.exports = __webpack_public_path__ + "img/bannerlogo.a01f5aef.jpg";